/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type ModalService from 'walden-trace-app/services/modal';

export interface ModalSignature {
  Args: {
    name: string;
    onClose?: () => void;
  };
  Blocks: {
    title: [];
    content: [];
    footer: [close: () => void];
  };
  Element: HTMLDialogElement;
}

export default class ModalComponent extends Component<ModalSignature> {
  @service('modal') declare modalService: ModalService;

  @action
  close() {
    if (this.args.onClose) {
      this.args.onClose();
    } else {
      this.modalService.close(this.args.name);
    }
  }
}
